const TYPES = {
  GET_BEACON_MENUS: 'GET_BEACON_MENUS',
  CREATE_BEACON_MENU: 'CREATE_BEACON_MENU',
  EDIT_BEACON_MENU: 'EDIT_BEACON_MENU',
  DELETE_BEACON_MENU: 'DELETE_BEACON_MENU'
};

export default TYPES;
